
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.219.625H7.188v12.5h10.937V4.53A3.906 3.906 0 0014.22.625zM4.371 13.172c.156-.031.314-.047.473-.047h.78V.703A3.906 3.906 0 002.5 4.531v9.395a3.87 3.87 0 011.871-.754zM18.125 14.688H4.844a2.344 2.344 0 100 4.687h9.375a3.906 3.906 0 003.906-3.906v-.781z","fill":"#3C464F"}})])
          )
        }
      }
    